import type { ISerialize } from '@/objects/ISerialize';

export class ISonenItem implements ISerialize {
    public APIID: number;

    public ClubID: number;

    public DescriptiveName: string | null;

    public Name: string | null;

    public OrganizerIDs: number[];

    /***
     * @deprecated Use the static FromJsValues method instead of the constructor to get type safety and default values
     */
    public constructor(values: {
        APIID?: number;
        ClubID?: number;
        DescriptiveName?: string | null;
        Name?: string | null;
        OrganizerIDs?: number[];
    }) {
        this.APIID = values.APIID ?? 0;

        this.ClubID = values.ClubID ?? 0;

        this.DescriptiveName = values.DescriptiveName ?? '';

        this.Name = values.Name ?? '';

        this.OrganizerIDs = values.OrganizerIDs ?? [];
    }

    public serialize(): string {
        return (
            '{' +
            `"APIID": ${JSON.stringify(this.APIID)}` +
            ',' +
            `"ClubID": ${JSON.stringify(this.ClubID)}` +
            ',' +
            `"DescriptiveName": ${JSON.stringify(this.DescriptiveName)}` +
            ',' +
            `"Name": ${JSON.stringify(this.Name)}` +
            ',' +
            `"OrganizerIDs": [ ${this.OrganizerIDs.map((x) => JSON.stringify(x))} ]` +
            '}'
        );
    }

    /**
     * Creates an instance of ISonenItem from the supplied values.
     * Missing values have default values
     * @param values The values you want to set
     * @returns An object instance with the supplied values set
     */
    public static FromJsValues(values: {
        APIID?: number;
        ClubID?: number;
        DescriptiveName?: string | null;
        Name?: string | null;
        OrganizerIDs?: number[];
    }): ISonenItem {
        return new ISonenItem(values);
    }

    public static _FromServerJson(json: any): ISonenItem {
        return new ISonenItem({
            APIID: json.APIID,
            ClubID: json.ClubID,
            DescriptiveName: json.DescriptiveName ?? '',
            Name: json.Name ?? '',
            OrganizerIDs: json.OrganizerIDs,
        });
    }

    /**
     * Creates an instance of ISonenItem from another instance of ISonenItem.
     * @param other The ISonenItem you want to clone
     * @returns A cloned ISonenItem
     */
    public static FromOther(other: ISonenItem): ISonenItem {
        return ISonenItem._FromServerJson(JSON.parse(other.serialize()));
    }

    /**
     * Deepclones the object.
     */
    public DeepClone() {
        return ISonenItem.FromOther(this);
    }

    static NAME_OF_CLASS = 'ISonenItem';
}
